import React from 'react';
import { ChevronDown, Play } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { assets } from '../mock';

const Hero = () => {
  const { t } = useLanguage();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={assets.heroVideo}
        poster={assets.heroPoster}
        autoPlay muted loop playsInline
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 text-center px-5 max-w-4xl mx-auto fade-in-slow">
        <div className="flex items-center justify-center gap-4 mb-7">
          <span className="h-px w-10 bg-[#e6b83f]/70" />
          <span className="font-sans-el text-[12px] sm:text-xs tracking-[0.4em] uppercase text-[#f5deA0]">
            {t.hero.eyebrow}
          </span>
          <span className="h-px w-10 bg-[#e6b83f]/70" />
        </div>

        <h1 className="font-deco font-bold leading-[1.02] text-4xl sm:text-6xl lg:text-7xl whitespace-pre-line">
          <span className="gold-gradient-text">{t.hero.title}</span>
        </h1>

        <p className="font-serif-el italic text-lg sm:text-2xl text-[#d8d2c4] mt-7 max-w-2xl mx-auto">
          {t.hero.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
          <button onClick={() => go('contact')} className="btn-gold px-8 py-4 rounded-sm text-[14px] tracking-[0.2em] uppercase font-medium w-full sm:w-auto">
            {t.hero.ctaPrimary}
          </button>
          <button onClick={() => go('video')} className="btn-ghost-gold px-8 py-4 rounded-sm text-[14px] tracking-[0.2em] uppercase font-medium inline-flex items-center justify-center gap-2 w-full sm:w-auto">
            <Play size={16} /> {t.hero.ctaSecondary}
          </button>
        </div>
      </div>

      <button
        onClick={() => go('about')}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-[#f5deA0]/80 hover:text-[#f5deA0] transition-colors"
      >
        <span className="font-sans-el text-[10px] tracking-[0.3em] uppercase">{t.hero.scroll}</span>
        <ChevronDown size={20} className="scroll-dot" />
      </button>
    </section>
  );
};

export default Hero;
